import React from 'react'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import OneModal from '../../../Components/OneModal/OneModal'
import { Button, Typography } from '@mui/material'
import { textoSx } from './ModalConfirmaApagaVisitanteContextSx'

export default function ModalConfirmaApagaVisitanteContext({
    open,
    setOpen,
    funcaoHandleClickEvento
}) {
    return (
        <OneModal
            open={open}
            setOpen={setOpen}
            titleText={'Confirmar '}
            FooterButtons={() => footerButtons(setOpen, funcaoHandleClickEvento)}
        >
            <Grid sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>

                <Typography sx={textoSx}>Você está prestes a perder seu progresso no tratamento do evento atual ao assumir outro evento igual à este.</Typography>

                <Typography sx={textoSx}>Deseja prosseguir?</Typography>
            </Grid>

        </OneModal >
    )
}

function footerButtons(setOpen, funcaoHandleClickEvento) {
    return (
        <Grid container xs={12} sx={{ justifyContent: 'space-between', width: '100%' }}>
            <Button color="success" variant="contained" onClick={() => { funcaoHandleClickEvento.funcao(); setOpen(false) }}> Sim </Button>
            <Button color="error" variant="contained" onClick={() => setOpen(false)} > Não </Button>
        </Grid >
    )
}
